/* eslint import/no-named-as-default-member: "off" */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./public/locales/en/translation.json";
import translationFR_CA from "./public/locales/fr-CA/translation.json";
import translationFR from "./public/locales/fr/translation.json";
const resources = {
  "en-CA": { translation: translationEN },
  "fr-CA": { translation: translationFR_CA },
  "fr-FR": { translation: translationFR },
};

void i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    debug: true,
    fallbackLng: "en",
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
